import FixedDepositCalcImg from "../../../images/Calculator/fixed-deposit-calc.svg";
import LumpsumCalcImg from "../../../images/Calculator/lumpsum-calc.svg";
import NpsCalcImage from "../../../images/Calculator/nps-calc.svg";
import NscImage from "../../../images/Calculator/nsc-logo.svg";
import PpfImage from "../../../images/Calculator/ppf-logo.svg";
import RecurringCalcImg from "../../../images/Calculator/recurring-deposit-calc.svg";
import ReverseSipCalcImg from "../../../images/Calculator/reverse-sip-calc.svg";
import SipCalcImg from "../../../images/Calculator/sip-calc.svg";
import SsyCalcImage from "../../../images/Calculator/ssy-calc.svg";
import StepUpSipCalcImg from "../../../images/Calculator/step-up-sip-calc.svg";
import SwpImage from "../../../images/Calculator/swp-logo.svg";

export const CALCULATORS = [
  "fixed-deposit-calculator",
  "mutual-fund-returns-calculator",
  "recurring-deposit-calculator",
  "sip-calculator",
  "reverse-sip-calculator",
  "step-up-sip-calculator",
  "nps-calculator",
  "sukanya-samriddhi-yojana-calculator",
  "swp-calculator",
  "ppf-calculator",
  "nsc-calculator"
];

export const getSelectedCalcData = selectedCalc => {
  switch (selectedCalc) {
    case "fixed-deposit-calculator":
      return data[0];

    case "mutual-fund-returns-calculator":
      return data[1];

    case "recurring-deposit-calculator":
      return data[2];

    case "sip-calculator":
      return data[3];

    case "reverse-sip-calculator":
      return data[4];

    case "step-up-sip-calculator":
      return data[5];

    case "nps-calculator":
      return data[6];

    case "sukanya-samriddhi-yojana-calculator":
      return data[7];

    case "swp-calculator":
      return data[8];

    case "ppf-calculator":
      return data[9];

    case "nsc-calculator":
      return data[10];

    default:
      console.log("Default case");
  }
};

const data = [
  {
    name: "Fixed Deposit Calculator",
    detailed_description:
      "The FD Calculator will calculate the Maturity Amount you would earn through the fixed deposit. The FD Calculator gives you an idea of how much return you can expect based on your investment. Just put the amount you want to save and the duration you wish to invest for.",
    description:
      "The FD Calculator will calculate the Maturity Amount you would earn through the fixed deposit. The FD Calculator gives you an idea of how much return you can expect based on your investment. Just put the amount you want to save and the duration you wish to invest for.",
    shortDescription:
      "Use this Fixed Deposit (FD) calculator to find out Maturity Amount you would earn through a Fixed Deposit",
    qATitle: "Parameters used in the Fixed Deposit Calculator",
    qA: [
      {
        question: "Is Return of FD taxable?",
        answer:
          "The returns on FD is taxable and withdrawing money before maturity can lead to penalties. The taxation feature of FDs will not help you beat inflation if you fall in the higher tax bracket"
      },
      {
        question: "What is the Investment Duration?",
        answer:
          "Fixed Deposit has a time period for which the sum invested gets fixed or locked."
      }
    ],
    calculatorUrl: "fixed-deposit-calculator",
    fieldValues: [
      {
        label: "Investment Amount",
        default: 5000,
        field: "investmentAmount",
        type: "input",
        readOnly: false
      },
      {
        label: "Expected Annual Return Rate(%)",
        default: "6",
        field: "returnRate",
        type: "input",
        readOnly: false
      },
      {
        label: "Year",
        default: 6,
        field: "year",
        type: "input",
        min: 1,
        max: 30,
        display: "Year"
      },
      {
        label: "Month",
        default: 4,
        field: "month",
        type: "input",
        min: 0,
        max: 11,
        display: "Month"
      }
    ],
    imgSrc: FixedDepositCalcImg
  },

  {
    name: "Mutual Fund Returns Calculator (Lumpsum)",
    detailed_description:
      "Mutual funds are great investment instruments for people who wish to park their surplus money and make it grow. Investing in mutual funds does not require a deep understanding of the concept, having some basic knowledge is more than enough to start investing in mutual funds.",
    description:
      "Mutual Fund Returns Calculator will reveal your net worth of investments in the future, taking into consideration the various variables like the investment duration and expected rate of return.",
    shortDescription:
      "Use this Mutual Fund Returns calculator to check the future value of your investments and the returns generated by them",
    // qATitle: 'Parameters used in the Mutual Fund Returns Calculator',
    qA: [
      {
        question: "How do mutual funds work?",
        answer:
          "Mutual funds are investment instruments which club the investments from various investors and invests them in the stock market under a given scheme. These funds are managed by a special body called Asset Management Company (AMC). "
      },
      {
        answer:
          "The total pooled money is invested in different types of securities like debt funds, equity funds, bonds, etc. the funds are managed by an expert called Fund Manager as appointed by the AMC. A fund manager is responsible for managing the funds in accordance with the market corrections and creates wealth for the investors. An annual fee termed as Expense Ratio is charged from the investors against the services, they avail which is mainly managing their portfolio. The returns are generally in the form of capital appreciation or dividends. There is an option with the investors to either earn the gains as regular income or they can reinvest the returns back to the investment amount. "
      },
      {
        question: "Why mutual funds?",
        answer:
          "There are several reasons that support investments in mutual funds. They are easy, accessible and much more. Here are a few of them:"
      },
      {
        question: "1. Ease of use",
        answer:
          "Mutual fund investing has become very convenient over the course of time. There is no need for paper-work or timing the market. Everything is online and super-fast. There are a lot of facilities with mutual fund investing like portfolio management, plan switch, etc. it takes just a few minutes to get going with your first investment and many more to come. "
      },
      {
        question: "2. Start small",
        answer:
          "This is a great advantage when it comes to investing with mutual funds. You can start small, as low as Rs. 500 and increase the amount gradually as per convenience. SIP or systematic investment plan is a way of investing which allows investors to invest on a regular basis with a small amount of investment. Contradictory to lump sum investment, SIP allows investors to make a small contribution towards investment portfolio and create wealth"
      },
      {
        question: "3. Tax- saving",
        answer:
          "ELSS is Equity Linked Savings Schemes is an option offered by mutual funds which have benefits under the section 80C which allows investors to save taxes on investment up to Rs. 1,50,000. It requires a lock-in period of a minimum of three years."
      },
      {
        question: "4. Professional touch",
        answer:
          "The mutual funds are managed by experts called fund managers. These fund managers are supported by a team of financial researchers who maintain up-to-date information about market trends. The fund managers based on this data and his own experience manage your funds and makes the decision regarding selling or purchasing funds. The knowledge and skill set of fund managers goes beyond retail investors."
      },
      {
        question: "HOW MUTUAL FUND CALCULATOR WORK?",
        answer:
          "The mutual fund calculator calculates the final amount which will be received at the time of maturity by taking into consideration factors like total invested amount, tenure, expected rate of return, way of investment- SIP or Lump sum, frequency of SIP, etc. "
      }
    ],
    calculatorUrl: "mutual-fund-returns-calculator",
    fieldValues: [
      {
        label: "Investment Amount",
        default: 5000,
        field: "investmentAmount",
        type: "input",
        readOnly: false
      },
      {
        label: "Expected Annual Return Rate(%)",
        default: 6,
        field: "returnRate",
        type: "input",
        readOnly: false
      },
      {
        label: "Year",
        default: 6,
        field: "year",
        type: "input",
        min: 1,
        max: 30,
        display: "Year"
      },
      {
        label: "Month",
        default: 4,
        field: "month",
        type: "input",
        min: 0,
        max: 11,
        display: "Month"
      }
    ],
    imgSrc: LumpsumCalcImg
  },

  {
    name: "Recurring Deposit Calculator",
    detailed_description:
      "Recurring deposits, also known as RD are term deposits which allow people to make regular deposits and earn attractive interests on them. Account holders can choose the period of the deposits and even the amount to be deposited regularly. RD offers higher flexibility than Fixed Deposits and is therefore more apt for those individuals who earn regular income and are unable to make bulk deposits in one go. It inculcates a habit of saving among individuals across all income categories. Recurring Deposits are offered by all banks in India. Interest rates are very competitive among banks, usually ranging around 6-7%, which are fixed for a tenure that is once decided, doesn’t change during the tenure.",
    description:
      "The RD Calculator will calculate the Maturity Amount you would earn through your deposit made every month. Just put the amount you want to save and the duration you wish to invest for.",
    shortDescription:
      "Use this RD calculator to find out Maturity Amount you would earn through a Recurring Deposit",
    qATitle: "Notables with respect to Recurring Deposit",
    qA: [
      {
        question: "What is the Investment Duration?",
        answer:
          "Recurring Deposit has a time period for which the sums invested gets fixed or locked."
      },
      {
        question: "Is Return of RD taxable?",
        answer:
          "The returns on RD are taxable and also withdrawing money before maturity expires can lead to penalties. The taxation feature in RDs will not help you beat inflation if you fall in the higher tax bracket"
      },
      {
        question: "Premature Withdrawal or Breaking of RD",
        answer:
          "The amount can only be withdrawn on maturity. In case of emergency you can break your RD before maturity by closing your account. The bank may deduct 1 or 2 percent as interest penalty from the interest accrued on your RD amount for the period for which the amount was with the bank. The minimum lock in period is 3 months and if the depositor request a premature withdrawal before that, he earns zero interest and only the principal amount will be refunded to him. Apart from cancelled interest, any incentives offered are also withdrawn."
      },
      {
        question: "Partial Withdrawal of RD",
        answer:
          "Partial withdrawal is not allowed. However, some banks offer the facility to obtain loan or overdraft by keeping your deposit as collateral. On the other hand, premature withdrawals are allowed by post offices if you have an RD account with them for at least a year. The withdrawn amount is considered a loan, which has to be paid in lump sum."
      },
      {
        question: "Tax Exemption on Recurring Deposits",
        answer:
          "Earlier no tax was deducted on recurring deposit. With effect to 1st June, 2015, these deposits are subject to TDS (tax deducted at source) as per the income tax laws. However, no TDS would be deducted if the interest income earned does not exceed Rs. 10,000 in a financial year. Tax is to be paid as per applicable slabs at the time of filing income tax return. If you have submitted Form 15G (in case of normal citizens) and 15H (in case of senior citizen) in the bank, your TDS will not be deducted (in case your total taxable income doesn’t come under tax slab)."
      },
      {
        question: "RD for Senior Citizens",
        answer:
          "Senior citizens can also open a RD account. The rate of interest they earn is slightly higher than the regular deposits available to other citizens. Generally banks offer 0.25 percent to 0.75 percent more interest than normal RDs, compounded annually and the tenure and amount is fixed by banks. Indian residents and NRIs both can open this account."
      }
    ],
    calculatorUrl: "recurring-deposit-calculator",
    fieldValues: [
      {
        label: "Investment Amount",
        default: 5000,
        field: "investmentAmount",
        type: "input",
        readOnly: false
      },
      {
        label: "Expected Annual Return Rate(%)",
        default: 6,
        field: "returnRate",
        type: "input",
        readOnly: false
      },
      {
        label: "Year",
        default: 6,
        field: "year",
        type: "input",
        min: 1,
        max: 30,
        display: "Year"
      },
      {
        label: "Month",
        default: 4,
        field: "month",
        type: "input",
        min: 0,
        max: 11,
        display: "Month"
      }
    ],
    imgSrc: RecurringCalcImg
  },

  {
    name: "SIP Calculator",
    detailed_description: [
      {
        question: "",
        answer:
          "A SIP calculator is an online tool which allows you to calculate the right amount of periodic investment amount to be made in order to achieve the major financial goal. It traces out for you the best-suited investment plan depending on your current income and future financial goals. It allows you to invest small starting from Rs. 500 and increase up to no limit. It gives you an estimate regarding the maturity amount and the time span required to achieve that."
      },
      {
        question: "HOW DOES A SIP CALCULATOR WORK?",
        answer:
          "SIP calculator follows simple mathematics to generate results. It calculates the reruns by applying the compound interest formula on entered details. Following are the steps:"
      },
      {
        question: "",
        answer: [
          "1. Enter the amount you wish to invest as SIP, a minimum of Rs. 500 is required for making an initial investment.",
          "2. The rate of return depending on finds past performance is chosen",
          "3. Finally, you need to select the tenure of SIP. A minimum of 6 months is required to stay invested in a SIP but it is highly advisable to invest for a long-term in order to reap bigger benefits.",
          "4. The calculator makes the calculation and provides with a result which almost accurate as far as maturity amount is concerned. "
        ]
      }
    ],
    description:
      "SIP Calculator will reveal your net worth of investments in the future, taking into consideration the various variables like the investment duration and expected rate of return. This SIP Calculator will show you how small investments made at regular intervals can yield much better returns over a long period of time.",
    shortDescription:
      "Use this SIP calculator to check the future value of your SIP investments and the returns generated by them",
    qATitle: "SIP SYSTEMATIC INVESTMENT PLAN",
    qA: [
      {
        answer:
          "SIP is a systematic investment plan which allows the investor to invest a fixed amount at fixed intervals which are pre-determined in a systematic manner. These investments with SIP can be done on a yearly, half-yearly, quarterly, monthly or weekly basis. The biggest advantage of investing with SIP is that it manages your funds and investments allowing you to focus on other important things and tasks."
      },
      {
        answer:
          "While you invest with SIP over a long-term, the benefits are reaped at the time of returns as long-term systematic investment balances out the risk factor. SIPs are automatic transactions when it is time for the upcoming installment or payment. The next question which arises is how to go about SIP and what decides the amount of investment to be made."
      },
      {
        answer:
          "The simple answer to this question is the SIP Calculator. Depending on your financial goal, SIP calculator calculates the amount of investment you need to make for a certain time period in order to achieve that goal."
      },
      {
        answer:
          "This brings us to the next question, what is a SIP Calculator and how does it work?"
      },
      {
        question: "BENEFITS"
      },
      {
        answer:
          "Following are the benefits of SIP over one-time lump sum investment:"
      },
      {
        answer: [
          "1. Disciplined investment approach",
          "2. Allows you to start small and increase the investment amount gradually",
          "3. Comes with two beneficial investment strategies-",
          [
            "Power of compounding- the returns are compounded making the amount huge. The basic fundamental behind compounding working on SIPs is that it puts your money to work. We have mentioned this phenomenon in a lot of our articles, which means that not only you work to earn that money but also your already earned money does so. As explained above, since the interest earned is also added to the next year’s principal amount, the earned interest is put back to work and generate more returns.",
            "Rupee cost averaging- balances out the risk and volatility. This phenomenon is very helpful in making buying-selling decisions depending on the market situation. It helps you buy funds when the market is low and sell when high hence balancing or averaging out the losses and risks."
          ],
          "4. Easy to use.",
          "5. Timing the market is not required."
        ]
      },
      {
        question: "HOW TO MAKE THE MAXIMUM OUT OF SIP?"
      },
      {
        subHeading: "A. Start early",
        answer:
          "As we have already mentioned, the sooner the better. The earlier you start, the bigger are the returns. Also, start early for a longer investment span. Stretch that investment window of yours to a really long time say 40 years or 30 years and realize the oceans of wealth gained."
      },
      {
        answer:
          " While you are still young and earning, it won’t trouble you much to take out a small portion from your regular income as compared to starting in the later years when there are tons of responsibilities."
      },
      {
        subHeading: "B. Be sincere and regular",
        answer:
          "There is always an excuse to stop that investment or stick to a particular amount that you started off with. Even if the returns are obvious, people tend to be sluggish when it comes to increasing the investment amount."
      },
      {
        answer:
          "This can be resolved by investing through the SIP method. It is a systematic and automatic investment system which allows you to invest every month, a pre-fixed amount to your investment portfolio and averages out the volatility market shows over a period of time."
      },
      {
        subHeading: "C. Choose high return instruments",
        answer:
          "It is very important to choose your investment instrument rightly. Although we Indians have the instinct to go towards 100% safe instruments, the loss is realized at the time of maturity. If you happen to invest Rs. 1,00,000 in a bank Fixed Deposit at the interest rate of 7% for say 20 years, you will be awarded Rs. 3,87,000 at the time of maturity."
      },
      {
        answer:
          "Whereas if you choose an instrument with almost 14% interest rate an invest the same amount for 20 years, you are awarded Rs. 13,74,000."
      },
      {
        answer:
          "The difference is 10 times which is quite evident. Hence, be very careful where you invest your money."
      },
      {
        subHeading: "D. Endurance is the key",
        answer:
          "Stay calm and patient. Do not panic if there are temporary market lows. They will fade away soon and if in case you happen to incur any loss, it will be averaged out in the long-term. A high is bound to come after a low. That is how the market works and your money grows. Be assured of the compounding working on your money."
      },
      {
        subHeading: "E. Cultivate a habit",
        answer:
          "With this initial investment, commit to yourself a habit of investment for a better and wealthy future. Start investing and stay invested. "
      }
    ],
    calculatorUrl: "sip-calculator",
    fieldValues: [
      {
        label: "Investment Amount (Monthly)",
        default: 5000,
        field: "investmentAmount",
        type: "input",
        readOnly: false
      },
      {
        label: "Expected Annual Return Rate(%)",
        default: 6,
        field: "returnRate",
        type: "input",
        readOnly: false
      },
      {
        label: "Year",
        default: 6,
        field: "year",
        type: "input",
        min: 1,
        max: 30,
        display: "Year"
      },
      {
        label: "Month",
        default: 4,
        field: "month",
        type: "input",
        min: 0,
        max: 11,
        display: "Month"
      }
    ],
    imgSrc: SipCalcImg
  },

  {
    name: "Reverse SIP Calculator",
    detailed_description:
      "Suppose you want to have Rs. 25 lakhs in 5 years. How much should you save and invest using SIP on a monthly basis from now until then? Use Reverse SIP calculator to see how much money will you need to save today to meet your future needs.",
    description:
      "Suppose you want to have Rs. 25 lakhs in 5 years. How much should you save and invest using SIP on a monthly basis from now until then? Use Reverse SIP calculator to see how much money will you need to save today to meet your future needs.",
    shortDescription:
      "Use Reverse SIP calculator to see how much money will you need to save today to meet your future needs",
    qA: [
      {
        // question: 'What is the total number of years?',
        // answer: 'Open a fixed deposit with Axis Bank and use the FD Calculator to calculate your total investment and returns on your fixed deposit. The FD Calculator gives you an idea of how much return you can expect based on your investment. FD’s can be made for your future needs and can be utilised as per your requirements. Grow your money with Fixed Deposits and get good returns. And before you invest, punch in your details in the Fixed Deposit Calculator provided by Axis Bank and get an estimate of your investments & returns.',
      },
      {
        // question: 'What is the total number of years?',
        // answer: 'Open a fixed deposit with Axis Bank and use the FD Calculator to calculate your total investment and returns on your fixed deposit. The FD Calculator gives you an idea of how much return you can expect based on your investment. FD’s can be made for your future needs and can be utilised as per your requirements. Grow your money with Fixed Deposits and get good returns. And before you invest, punch in your details in the Fixed Deposit Calculator provided by Axis Bank and get an estimate of your investments & returns.',
      }
    ],
    calculatorUrl: "reverse-sip-calculator",
    fieldValues: [
      {
        label: "Target Amount",
        default: 5000,
        field: "investmentAmount",
        type: "input",
        readOnly: false
      },
      {
        label: "Expected Annual Return Rate(%)",
        default: 6,
        field: "returnRate",
        type: "input",
        readOnly: false
      },
      {
        label: "Year",
        default: 6,
        field: "year",
        type: "input",
        min: 1,
        max: 30,
        display: "Year"
      },
      {
        label: "Month",
        default: 4,
        field: "month",
        type: "input",
        min: 0,
        max: 11,
        display: "Month"
      }
    ],
    imgSrc: ReverseSipCalcImg
  },

  {
    name: "Step Up SIP Calculator",
    detailed_description:
      "With Step-up SIP you can start investing an initial amount and then gradually increase it till it reaches the final amount e.g., if your initial investment amount is 1000 per month and you specified a step-up of 10%, it will become 1100 in the second year, 1210 in the third year and so on.",
    description:
      "With Step-up SIP you can start investing an initial amount and then gradually increase it till it reaches the final amount e.g., if your initial investment amount is 1000 per month and you specified a step-up of 10%, it will become 1100 in the second year, 1210 in the third year and so on.",
    shortDescription:
      "Use this Step Up SIP calculator to check the future value of your investments and the returns generated by them.",
    qA: [
      {
        question: "How Step up SIP helps?",
        answer:
          "Increasing your investment amount with respect to your income will lead to generate more wealth in the long term."
      }
    ],
    calculatorUrl: "step-up-sip-calculator",
    fieldValues: [
      {
        label: "Investment Amount",
        default: 5000,
        field: "investmentAmount",
        type: "input",
        readOnly: false
      },
      {
        label: "Expected Annual Return Rate(%)",
        default: 6,
        field: "returnRate",
        type: "input",
        readOnly: false
      },
      {
        label: "Annual Step Up(%)",
        default: 10,
        field: "stepUp",
        type: "input",
        readOnly: false
      },
      {
        label: "Year",
        default: 6,
        field: "year",
        type: "input",
        min: 1,
        max: 30,
        display: "Year"
      },
      {
        label: "Month",
        default: 4,
        field: "month",
        type: "input",
        min: 0,
        max: 11,
        display: "Month"
      }
    ],
    imgSrc: StepUpSipCalcImg
  },

  {
    name: "National Pension Scheme (NPS) Calculator",
    detailed_description:
      "National Pension Scheme (NPS) is a government initiative that enables its subscribers to contribute to his/her pension during the working life. This is a govt sponsored pension scheme launched in 2004.\nThis scheme basically allows you to contribute a minimum of Rs 6000 per year in your own pension scheme and reap benefits post retirement.  It is controlled by pension fund regulatory development authority (PFRDA).\nNPS Calculator is a tool which provides with the estimates regarding retirement fund you will receive at age 60. It computes the total amount receivable and interest gained.",
    description:
      "National Pension Scheme (NPS) is a government initiative that enables its subscribers to contribute to his/her pension during the working life. This is a govt sponsored pension scheme launched in 2004.\nThis scheme basically allows you to contribute a minimum of Rs 6000 per year in your own pension scheme and reap benefits post retirement.  It is controlled by pension fund regulatory development authority (PFRDA).\nNPS Calculator is a tool which provides with the estimates regarding retirement fund you will receive at age 60. It computes the total amount receivable and interest gained.",
    shortDescription:
      "Use this National Pension Scheme (NPS) calculator to make estimates regarding retirement fund you will receive at age 60.",
    qA: [
      {
        question: "Eligibility Criteria for National Pension Scheme",
        answer:
          "Indian citizens between the age of 18 to 60 can opt for the scheme."
      },
      {
        question: "Key Rules",
        answer: [
          "Minimum annual deposit should be Rs. 6000",
          "Ages limit is 18 to 60 years",
          "Withdrawal at the time of retirement is distributed into lumpsum and annuity scheme",
          "Maximum 40% of the total corpus can be withdrawn tax-free",
          "40% must be invested in annuity scheme for regular monthly income post retirement",
          "Remaining 20% can also be invested in annuity plan or withdrawn as lumpsum with tax applicability."
        ]
      },
      {
        question: "Categories of NPS Accounts",
        answer: [
          "Tier 1 Account: These accounts have restrictions on premature withdrawal. These are more of corporate accounts where in the employer also contributes to employee’s NPS account. Wipro was the first private organisation to start with NPS accounts for employees.",
          "Tier 2 Account: These accounts are more of voluntary accounts which have no restriction over withdrawals. To open a Tier 2 account, Tier 1 account is mandatory."
        ]
      }
    ],
    calculatorUrl: "nps-calculator",
    fieldValues: [
      {
        label: "Every Month Contribution",
        default: 5000,
        type: "input",
        field: "investmentAmount",
        readOnly: false
      },
      {
        label: "Age",
        default: 24,
        type: "input",
        field: "age",
        min: 18,
        max: 60,
        display: "Years"
      },
      {
        label: "Expected Return Rate",
        default: "10",
        type: "input",
        field: "returnRate",
        readOnly: false
      },
      {
        label: "Annuity(%)",
        default: 60,
        type: "input",
        field: "annuity",
        min: 40,
        max: 100,
        display: "%"
      },
      {
        label: "Expected Annuity Rate(%)",
        default: 6,
        type: "input",
        field: "annuityRate",
        readOnly: false
      }
    ],
    imgSrc: NpsCalcImage
  },
  {
    name: "Sukanya Samriddhi Yojana Calculator",
    detailed_description:
      "As they say, educate the girl and the whole family will be educated. Sukanya Samriddhi Yojana is a step towards realising this saying. The Indian Government back in 2015 started a savings scheme which enables parents to save in the name of their girl child primarily for her education and her wedding as well. SSY is a risk-free deposit scheme which is launched under the campaign “Beti Bachao Beti Padhao” of the Indian govt. Apart from being risk-free; another highlight of this scheme is that it comes with a tax-benefit as well. And to add to it, the maturity amount as well as the interest is tax exempted.",
    description:
      "As they say, educate the girl and the whole family will be educated. Sukanya Samriddhi Yojana is a step towards realising this saying. The Indian Government back in 2015 started a savings scheme which enables parents to save in the name of their girl child primarily for her education and her wedding as well. SSY is a risk-free deposit scheme which is launched under the campaign “Beti Bachao Beti Padhao” of the Indian govt. Apart from being risk-free; another highlight of this scheme is that it comes with a tax-benefit as well. And to add to it, the maturity amount as well as the interest is tax exempted.",
    shortDescription:
      "Use this calculator to make estimates of the maturity amount for the deposit scheme launched under Beti Bachao, Beti Padhao campaign",
    qA: [
      {
        question: "Eligibility Criteria",
        answer: [
          "The girl child should be a citizen of India",
          "She must not have exceeded the age of 10 years at the time of starting the scheme",
          "Sukanya samriddhi Yojana scheme account is allowed only for 2 girl children belonging to the same family."
        ]
      },
      {
        question: "Money deposit Rules",
        answer: [
          "A minimum deposit of Rs. 250 is mandatory per annum failing which the account would be declared inactive",
          "A maximum deposit of Rs. 1.5 Lakh per annum is allowed",
          "The account holds good till the time the girl child attains the age of 21 years or gets married, which ever of the two occurs first. The initial minimum deposit has been kept nominal by the Govt of India which is Rs. 250 only. The number of deposits in a month or year are unlimited.",
          "Also there is a provision of partial withdrawal at the age of 18 years for education or marriage."
        ]
      },
      {
        question: "Interest rate",
        answer:
          "Sukanya samriddhi Yojana Scheme offers the best RoI among other saving schemes which is 8.3% presently. The GOI holds right to alter this interest rate as per requirement. "
      },
      {
        question:
          "Points to remember while opening a Sukanya samriddhi Yojana account",
        answer: [
          "Sukanya samriddhi Yojana scheme is only for girl child of Indian origin",
          "Maximum permissible age is 10 years at the time of account opening",
          "Sukanya samriddhi Yojana is only allowed for 2 girls children of the same family",
          "Total tenure is 21 years",
          "Deposits need to be made only till year 14",
          "Sukanya samriddhi Yojana comes with tax benefit"
        ]
      }
    ],
    calculatorUrl: "sukanya-samriddhi-yojana-calculator",
    fieldValues: [
      {
        label: "Girl Child's Age",
        default: 1,
        type: "input",
        field: "ssyAge",
        min: 1,
        max: 10,
        display: "Years"
      },
      {
        label: "Annual Deposit(₹)",
        default: 250,
        type: "input",
        min: 250,
        max: 150000,
        display: "",
        field: "investmentAmount",
        step: 50
      },
      {
        label: "Return Rate",
        default: 8.3,
        type: "input",
        field: "ssyReturnRate",
        readOnly: true
      }
    ],
    imgSrc: SsyCalcImage
  },
  {
    name: "Systematic Withdrawal Plan Calculator",
    detailed_description:
      "A Systematic Withdrawal Plan (SWP) allows an investor to withdraw a specific amount from their lump sum investments periodically. You can set an Systematic Withdrawal Plan to be either monthly, quarterly or annually.",
    description:
      "A Systematic Withdrawal Plan (SWP) allows an investor to withdraw a specific amount from their lump sum investments periodically. You can set an Systematic Withdrawal Plan to be either monthly, quarterly or annually.",
    shortDescription:
      "Use this SWP Calculator, to make fixed withdrawals at regular time periods from your lumpsum investments.",
    qA: [
      {
        question: "What is Systematic Withdrawal Plan (SWP) Calculator?",
        answer:
          "An Systematic Withdrawal Plan (SWP) calculator takes into consideration the returns from your investment to give you the total value of your investment at the end of your SWP tenure."
      },
      {
        question: "When should you use an Systematic Withdrawal Plan (SWP)?",
        answer:
          "Investment consultants and mutual fund advisors are recommending SWP to retired folks as the best way to draw a regular income from their mutual fund investments. However, it is a useful financial facility for investors of all age groups, as it allows investors to withdraw a fixed amount at a predetermined regular interval and at the same time ensure their remaining investment is helping them generate additional returns."
      },
      {
        question: "How does a Systematic Withdrawal Plan (SWP) work?",
        answer: [
          "Let’s use an example to better understand the SWP Calculations.",
          "Imagine you have invested Rs. 10,00,000 in a mutual fund scheme and you wish to withdraw Rs. 10,000 every month for the next 3 years through your systematic withdrawal plan.",
          "Let us assume the Net Asset Value (NAV) of the scheme is Rs. 10. With the investment of Rs. 10,00,000, you have accumulated 1,00,000 units in the Mutual Fund.",
          "The withdrawal of Rs. 10,000 from this scheme will mean that 1,000 units will be sold (Rs. 10,000/Rs.10).",
          "The remaining amount in your mutual fund post the first withdrawal will be 99,000 units (1,00,000-1,000).",
          "At the start of the next month, if the NAV of your Mutual Fund scheme increases to Rs. 20, then the withdrawal of Rs. 10,000 would mean, sale of 500 units,(Rs. 10,000/20).",
          "The mutual fund will then be left with 98,500 units, after the second withdrawal.",
          "This is how the Systematic Withdrawal Plan (SWP) works to help investors generate extra returns while ensuring a fixed amount of regular withdrawal."
        ]
      },
      {
        question: "What are the withdrawal options available for an investor?",
        answer: [
          "Under the Systematic Withdrawal Plan (SWP), the withdrawal amount is fixed and an investor can choose the regular withdrawal interval.",
          "An investor can choose to either withdraw a fixed amount on a monthly or a quarterly or annually.",
          "With the Appreciation Withdrawal Option (AWO), an investor may choose to withdraw only the appreciated amount on a monthly, quarterly or on an annual time period.",
          "Withdrawal options can have a detrimental effect on the value of the investment and it is recommended that an investor opts for a realistic withdrawal amounts, keeping in mind their needs and their end goals."
        ]
      },
      {
        question:
          "What are the Tax Implications of Systematic Withdrawal Plans?",
        answer: [
          "The redemption of a Systematic Withdrawal Plan is subject to taxation.",
          "If an investor’s holding period is less than 36 months, then the amount that the investor withdraws at regular intervals will form a part of their income and will then be taxed in accordance to their income tax slab.",
          "However, if the holding period of the investor is more than 36 months, then the amount that the investor withdraws will be subjected to Long-Term Capital Gains (LTCG) Tax which is 10 percent without indexation and 20 percent with indexation."
        ]
      }
    ],
    calculatorUrl: "swp-calculator",
    fieldValues: [
      {
        label: "Total Investment Amount",
        default: 10000,
        field: "investmentAmount",
        type: "input",
        readOnly: false
      },
      {
        label: "Expected Annual Return Rate(%)",
        default: 6,
        field: "returnRate",
        type: "input",
        readOnly: false
      },
      {
        label: "Withdrawal per month",
        default: 0,
        type: "input",
        field: "withdrawal",
        readOnly: false
      },
      {
        label: "Year",
        default: 6,
        field: "year",
        type: "input",
        min: 1,
        max: 30,
        display: "Year"
      }
    ],
    imgSrc: SwpImage
  },
  {
    name: "Public Provident Fund Calculator",
    detailed_description:
      "PPF stands for Public Provident Fund which is a scheme initiated by the NSO (National Savings Organisations) in 1968. The PPF scheme was started in order to promote small investments and savings. This is a fixed returns scheme providing with tax benefits as well under the Section 80C.",
    description:
      "PPF stands for Public Provident Fund which is a scheme initiated by the NSO (National Savings Organisations) in 1968. The PPF scheme was started in order to promote small investments and savings. This is a fixed returns scheme providing with tax benefits as well under the Section 80C.",
    shortDescription:
      "Use this PPF calculator to calculate your Public Provident Fund Interest / returns. Know about PPF benefits and how it helps you in saving taxes.",
    qA: [
      {
        question: "How To Open a PPF Account?",
        answer:
          "Banks like ICICI, AXIS, HDFC, CENTRAL BANK OF PUNJAB, BOI, IDBI, CENTRAL BANK OF INDIA, PNB, INDIAN OVERSEAS BANK etc. and only SBI’s designated branches are functional at opening PPF accounts of customers along with its subsidiaries."
      },
      {
        question:
          "List of documents required for opening the account both online and offline/physically:- ",
        answer: [
          "1. Account opening form which can be availed and filled at the bank branch and portal of Indian Post.",
          "2. Proof of Identity which may be any of the following: Aadhar card: Driving license, PAN card, Voter Card, Passport",
          "3. Proof of address which may be any of the following: Aadhar card, Passport, Telephone bill, Electricity bill",
          "4. 2 latest photographs",
          "5. A cheque of the amount you wish to transfer to your PPF account signed in the favor of bank or pay-in-slip",
          "6. In case of a minor, the birth certificate may be required as proof of age."
        ]
      },
      {
        question: "Note: ",
        answer: [
          "1. You need to visit the bank branch you wish to open the account in and submit the necessary documents if you wish to open offline. Also, the copies of documents should be self-attested.",
          "2. Every bank has a different procedure to open a PPF account, visit the website of the bank you wish to open the account with."
        ]
      },
      {
        question: "PPF Account - Benefits",
        answer: [
          "1. Risk-free: This is a fixed return scheme offering a good 8% return annually. Moreover, the central government of India backs up the scheme.",
          "2. Power of compounding: By every March 31st, you are paid the interest earned on your investment which is compounded annually till the maturity or withdrawal.",
          "3. Tax deduction: Investing in PPF comes with Tax rebate on up to Rs. 1.5 Lacs under section 80C.",
          "4. Long-term investment: It is a very good option for those who wish to invest in the long term with assured returns.",
          "5. Start small: You can start small with PPF investment from Rs. 500 and increase it up to Rs. 1,50,000 as the maximum limit annually.",
          "6. Premature withdrawal: 7th year onwards the subscriber can avail partial withdrawal facility."
        ]
      },
      {
        question: "Interest Rate",
        answer:
          "The current interest rate offered by the government for the year 2019 is 8% as applicable 1st January onwards."
      },
      {
        question: "Case Of Minor - PPF Account",
        answer: [
          "In case you wish to open a PPF account for a minor that can be done by a parent on the behalf of the minor. Only one account can be opened against one minor by either of the parents.",
          "If the parents of the child are alive, grandparents are not allowed to open a PPF account against their grandchild.",
          "Note: As mentioned above, in case of a minor, a birth certificate would also be required."
        ]
      },
      {
        question: "Forms A to H Of PPF Account",
        answer: [
          "FORM A: To open a Public Provident Fund Account.",
          "FORM B: To make deposits and repay loans against the account.",
          "FORM C: To make partial withdrawals.",
          "FORM D: Applying for a loan against PPF account.",
          "FORM E: To add a nominee to the PPF account.",
          "FORM F: To change the nomination.",
          "FORM G: To claim funds which is done either by legal heir or nominee",
          "FORM H: To extend the maturity of the account"
        ]
      },
      {
        question: "Premature Closure",
        answer: [
          "Only after 5 years are complete, the premature closure is allowed for a PPF account. It has to be a case of critical illness/ medical reasons regarding family members or higher education of the account holder only.",
          "Note: If you wish to close the account on a premature basis, you will be charged with 1% penalty on the rate of interest i.e. if 8% is the running ROI, you will be paid as per 7% ROI on premature closure."
        ]
      },
      {
        question: "Transferring a PPF Account",
        answer: [
          "If you happen to be in a transferable job or for any reasons there are demographic changes happening, you can transfer your account to any other branch or bank or post office. There are no charges on account transfer.",
          "Follow these simple steps to transfer account:",
          "Step 1: Visit the bank/branch/PO where your PPF account is located and raise a transfer request",
          "Step 2: The bank/PO will forward the desired documents to the new location as mentioned by the subscriber. These may include account opening form A, nomination form, specimen signature etc.",
          "Step 3: Once the request is received by the new location, you will be contacted to produce the old account passbook and fill a new application form. At this stage, you can change/add/delete the nomination details.",
          "Step 4: In a few days, your account will be transferred to the new location which can be checked online through internet banking id. In case you are not able to locate the changes, please contact the concerned bank/branch/PO."
        ]
      },
      {
        question: "FAQ's Regarding PPF",
        answer: [
          "Q1.  Does PPF account get inactive?",
          "Yes, if you fail to deposit a minimum of Rs. 500 per year, your account will be considered inactive.",
          "Q2. How to reactivate an inactive PPF account?",
          "For every inactive year, you need to pay Rs. 50 plus the minimum cumulative amount for each year.",
          "Q3. What are the tax implications of a PPF account?",
          "A maximum of Rs. 1.5 lacs are tax exempted. The PPF falls under EEE type tax baskets where the maturity corpus and the interest earned are tax exempted on maturity.",
          "Q4. Can grandparents open a PPF account for their grandchild?",
          "In case the parents of the child/minor are alive, grandparents cannot do so."
        ]
      }
    ],
    calculatorUrl: "ppf-calculator",
    fieldValues: [
      {
        label: "Investment Amount (Min: 500 and Max: 150000)",
        default: 500,
        field: "investmentAmount",
        type: "input",
        useValidation: true,
        isValid(val) {
          if (val >= 500 && val <= 150000) return true;
          return false;
        },
        errorText: "Value should be atleast 500 and atmost 150000",
        readOnly: false,
        step: 100,
        minVal: 500,
        maxVal: 150000
      },
      {
        label: "Expected Annual Return Rate(%)",
        default: 8,
        field: "returnRate",
        type: "input",
        readOnly: true
      },
      {
        label: "Years",
        default: 15,
        field: "year",
        type: "input",
        readOnly: true,
        display: "Year"
      }
    ],
    imgSrc: PpfImage
  },
  {
    name: "National Savings Certificate Calculator",
    detailed_description:
      "The national savings certificate is an investment scheme that can be opened up with any post office in India. It is a fixed income scheme initiated by the government of India enabling the investors to save on taxes while investing in this savings bond. It is mainly targeted towards small and mid-income investors while anyone can opt for this scheme. This scheme like bank FDs or PO RDs or PPF is a low-risk scheme good for risk-averse people. There are two options in the maturity period; 5-year scheme and 10-year scheme. Although there is no cap on the maximum amount of scheme but an investment only up to Rs. 1.5 Lakh will fetch tax benefits under the Income Tax Act’s section 80C. the government keeps on revising the rate of interest every quarter which presently is 7.6%. the interest earned on the principal amount is added back and compounded annually till the time of maturity.",
    description:
      "The national savings certificate is an investment scheme that can be opened up with any post office in India. It is a fixed income scheme initiated by the government of India enabling the investors to save on taxes while investing in this savings bond. It is mainly targeted towards small and mid-income investors while anyone can opt for this scheme. This scheme like bank FDs or PO RDs or PPF is a low-risk scheme good for risk-averse people. There are two options in the maturity period; 5-year scheme and 10-year scheme. Although there is no cap on the maximum amount of scheme but an investment only up to Rs. 1.5 Lakh will fetch tax benefits under the Income Tax Act’s section 80C. the government keeps on revising the rate of interest every quarter which presently is 7.6%. the interest earned on the principal amount is added back and compounded annually till the time of maturity.",
    shortDescription:
      "Use NSC calculator to calculate the return on investment / current value of your National Savings Certificates (NSC).",
    qA: [
      {
        question: "Suitability Of The Scheme",
        answer: [
          "NSC is best suited for people who are risk averse and are looking for an option which is safe and saves taxes as well. This scheme also earns a regular and steady income. Since it is a low-risk scheme, it offers 100% capital protection and guaranteed returns. The only drawback with NSC is that it does not offer exponential returns like Mutual Funds (Which have a tax saving option as well like in ELSS) or National Pension Scheme. The interest rate for every quarter is fixed by the government.",
          "The biggest advantage with NSC apart from the security factor is that it has easy access. It being available at all post offices has an outreach to distant investors as well."
        ]
      },
      {
        question: "Eligibility For Investing In NSC",
        answer: [
          "This is an individual savings scheme; hence the following are eligible to opt for NSC.",
          "1. All residents of India",
          "2. Karta of HUFs (Hindu Undivided Family) in his/her name only"
        ]
      },
      {
        question: "Who cannot invest in NSC?",
        answer: ["1. Non-resident Indians", "2. Trusts", "3. HUFs"]
      },
      {
        question: "",
        answer:
          "Note: In the case of subscribers who opted for the scheme at a given time and then before maturity of the scheme move abroad or become NRI, the scheme will be held till maturity."
      },
      {
        question: "Important Features and Benefits Of NSC",
        answer: [
          "1. Guaranteed returns: The scheme comes with an annual rate of interest of 7.6% (currently 8%) offering guaranteed returns and fixed income.",
          "2. Variants: Originally there were two variants of NSC offered by the government; NSC VIII and NSC IX which were the 5-year and 10-year plans respectively. In December 2015, the NSC IX was discontinued leaving NSC VIII as the only option available.",
          "3. Tax saving: NSC allows tax savings on investments up to Rs. 1.5 lakh under the section 80C of IT Act.",
          "4. Bare minimum investment: You can start small with NSC as low as Rs. 100 or multiples to be the initial investment. This investment amount can be increased as and when appropriate.",
          "5. Rate of interest: The government keeps revising the ROI every quarter which currently is 8%. It offers an annual rate of interest of 7.6% approximately.",
          "6. Accessibility: It is quite easy to invest in the NSC by visiting any Post Office. All you need to do is submit the desired documents and be KYC compliant.",
          "7. Loan security: NSC is accepted as a security document by Banks and NBFCs while applying for loans. A transfer stamp to be put by the postmaster is required in order to transfer the account to the bank.",
          "8. Nomination: Any family member including the minors can be nominated for against the scheme.",
          "9. Withdrawal scheme: NSC can only be withdrawn upon maturity. No premature withdrawals are allowed except for in cases of emergency like death or critical illness (with court’s order).",
          "10. Maturity amount: Upon maturity, the full corpus is handed-over to the investor. No TDS is deducted in case of NSC. Hence the onus lies on the subscriber to pay tax as applicable."
        ]
      },
      {
        question: "Tax Benefit",
        answer:
          "NSC comes with a tax benefit on investment up to Rs. 1.5 Lakhs under the Income Tax Act’s Section 80C. Second year onwards, tax rebate can be claimed on the interest earned in the first year. This is so because the interest is compounded annually and added back to the initial investment."
      },
      {
        question: "Documents Required",
        answer: [
          "1. NSC application form duly filled",
          "2. POI (Proof of Identity)",
          "3. POA (Proof of Address)",
          "4. Photograph",
          "5. Investment deposit- cash or cheque"
        ]
      }
    ],
    calculatorUrl: "nsc-calculator",
    fieldValues: [
      {
        label: "Investment Amount (Min: 100)",
        default: 100,
        field: "investmentAmount",
        type: "input",
        useValidation: true,
        isValid(val) {
          if (val < 100) return false;
          return true;
        },
        errorText: "Value should not be less than 100",
        readOnly: false,
        minVal: 100
      },
      {
        label: "Expected Annual Return Rate(%)",
        default: 8,
        field: "returnRate",
        type: "input",
        readOnly: true
      },
      {
        label: "Time Period",
        default: 5,
        field: "year",
        type: "radio",
        options: [
          { label: "5 Yrs", value: 5 },
          { label: "10 Yrs", value: 10 }
        ],
        display: "Year"
      }
    ],
    imgSrc: NscImage
  }
];

export default data;
